module.exports = __webpack_public_path__ + "assets/media/bot_flow.c12b39a3.svg";